//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import Url from 'drip/utils/url';
export default {
  name: 'GrabLeak',
  props: {},
  data: function data() {
    return {};
  },
  computed: {},
  watch: {
    // dailyCouponData: 'initData'
  },
  mounted: function mounted() {
    window.seedAction({
      evt: 'view',
      bid: 'b_movie_e4gfkopp_mv',
      performance_id: '',
      marketing_type: 2 // 1.天天神券 2.捡漏拍
    });
  },

  methods: {
    jumpToLeakageList: function jumpToLeakageList() {
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_e4gfkopp_mc',
        performance_id: '',
        needTag: true,
        marketing_type: 2 // 1.天天神券 2.捡漏拍
      });

      Drip.redirect(Url.getUrl('/myshowfe/trade/detect-leakage/list', {
        _blank: true
      }));
    }
  }
};